























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Machine } from "@/models/machine";
import moment from "moment";

@Component({})
export default class ConfirmExportDialogComponent extends Vue {

  @Prop({ default: '' })
  public title!: string;

  @Prop({ default: false })
  public showYears!: boolean;



  @Prop({ default: () => [] })
  public multiple!: Machine[];

  public items: any = []

  public language: string = 'de';

  public selected: string[] = [];
  public selectedYear: number = 2026;
  private keyToMaintId: Record<string, string> = {}; // Key -> maint.id
  private uniqKeys = new Set<string>(); // doppelte Einträge verhindern

  public get showLanguageSelection(): boolean {
    return this.title === 'Wartungs-Export' || this.title === 'Bestandsaufnahmelisten Export';
  }



  public mounted() {
    this.items = this.convertToTreeViewObject();
  }

  public reloadItems() {
    this.items = this.convertToTreeViewObject();
  }


  public selectAll() {
    this.selected = this.getLeafNodes(this.items);
  }

  public deselectAll() {
    this.selected = [];
  }



  public getLeafNodes(items: any[]): any[] {
    const leaf: any[] = [];
    function walk(nodes: any[]) {
      nodes.forEach(n => {
        if (!n.children || n.children.length === 0) leaf.push(n.id);
        else walk(n.children);
      });
    }
    walk(items);
    return leaf;
  }

  public convertToTreeViewObject() {
    this.keyToMaintId = {};
    this.uniqKeys.clear();

    const res: any[] = [];

    this.multiple.forEach(machine => {
      machine.maintenances.forEach(maint => {
        if (this.inSelectedYear(maint.createdAt)) {
          // eindeutiger Key pro Leaf:
          const key = `${machine.id}__${maint.id}`;
          if (this.uniqKeys.has(key)) return; // Duplikate überspringen
          this.uniqKeys.add(key);

          this.keyToMaintId[key] = String(maint.id);

          res.push({
            id: key, // <- eindeutiger Key für v-treeview
            name: `TagNo - ${machine.tagNo}`,
            // Optional: wenn du Datum zeigen willst
            // subtitle: `Abgeschl. Wartung: ${moment(maint.createdAt).format('ll')}`,
          });
        }
      });
    });

    return res;
  }

  public inSelectedYear(socke: any) {
    var momentDate = moment(socke);
    var startDate = moment(this.selectedYear, 'YYYY');
    var endDate = moment(this.selectedYear + 1, 'YYYY');

    return momentDate.isBetween(startDate, endDate);
  }

  public confirmedWithImage() {
    const maintIds = this.selected.map(k => this.keyToMaintId[k] ?? k);
    this.$emit('closeDialog', { withImages: true, language: this.language, items: maintIds });
  }

  public confirmedWithoutImage() {
    const maintIds = this.selected.map(k => this.keyToMaintId[k] ?? k);
    this.$emit('closeDialog', { withImages: false, language: this.language, items: maintIds });
  }

  public closed() {
    this.$emit('closeDialog');
  }

}

